import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { GtwSearchableSelectDirective } from './gtw-searchable-select.directive';
import { GtwSearchableSelectPanelComponent } from './gtw-searchable-select-panel.component';

/**
 * Standalone-ready module. Import in any feature module that wants to add
 * the `gtwSearchableSelect` attribute to existing native <select> elements.
 *
 *   @NgModule({
 *     imports: [..., GtwSearchableSelectModule],
 *     ...
 *   })
 */
@NgModule({
  declarations: [GtwSearchableSelectDirective, GtwSearchableSelectPanelComponent],
  imports: [CommonModule, FormsModule, OverlayModule, PortalModule],
  exports: [GtwSearchableSelectDirective],
})
export class GtwSearchableSelectModule {}
